
import { defineComponent } from "vue";

import FormieForm from "~/vue/organisms/forms/FormieForm.vue";
export default defineComponent({
	components: {
		"form--primary": FormieForm,
	},
});
